(function() {
    'use strict';

    angular.module('app.usuarios-organizador', []);
})();
